// External Dependencies
import { Formik, Form } from 'formik';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

// Internal Dependencies
import {
  CustomFormButton,
  CustomInput,
  ErrorMessage,
} from './shared';
import {
  validateEmail,
  validatePasswordLength,
} from '../utils';

// Local Typings
interface Props {
  error: string;
  onSubmit: (values: any) => void;
}

// Local Variables
const StyledForm = styled(Form)({
  '.custom-button': {
    margin: 10,
    padding: '6px 48px',
  },
  boxSizing: 'border-box',
  maxWidth: 368,
  padding: '24px 0',
});

// Component Definition
const SignUpForm = ({
  error = '',
  onSubmit,
}: Props): JSX.Element => {
  const validate = (values: any) => {
    const errors: any = {};

    if (validateEmail(values.email)) {
      errors.email = 'Invalid email';
    }

    if (validatePasswordLength(values.password)) {
      errors.password = 'Password must be at least 6 characters long';
    }

    // map over values and make all required
    Object.entries(values).forEach(([k, v]) => {
      if (!v) {
        errors[k] = 'Required';
      }
    });

    // is passwords do not match
    if (values.password !== values.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }
    return errors;
  };

  return (
    <Formik
      initialValues={{
        confirmPassword: '',
        email: '',
        firstName: '',
        lastName: '',
        password: '',
      }}
      onSubmit={async (values, { setSubmitting }) => {
        // do code here to submit
        await onSubmit(values);
        setSubmitting(false);
      }}
      validate={validate}
    >
      {({ isSubmitting }) => (
        <StyledForm>
          <Typography variant="h6">
            Sign Up
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            gap={1.5}
            py={2}
          >
            <CustomInput
              fullWidth
              label="First Name"
              name="firstName"
            />
            <CustomInput
              fullWidth
              label="Last Name"
              name="lastName"
            />
            <CustomInput
              fullWidth
              label="Email"
              name="email"
              type="email"
            />
            <CustomInput
              fullWidth
              label="Password"
              name="password"
              type="password"
            />
            <CustomInput
              fullWidth
              label="Confirm Password"
              name="confirmPassword"
              type="password"
            />
          </Box>

          <CustomFormButton
            buttonText="Sign Up"
            className="custom-button"
            disabled={isSubmitting}
          />

          <ErrorMessage
            condition={!!error}
            message={error}
          />
        </StyledForm>
      )}
    </Formik>
  );
};

export default SignUpForm;
